import { DiscountState } from "./discount.types";
import { Dispatch } from "redux";
import { IAction, IStore } from "../store";
import { FAILURE, REQUEST, SUCCESS } from "../../utils/actionsTypes";
import { preventivoSelector } from "./discount.selectors";
import { Api } from "../../api";
import { EngineActionType } from "../engine/engineReducer";

export enum DiscountActionType {
  APPLY_VOUCHER = "discount/APPLY_VOUCHER",
  APPLY_FAMIGLIA = "discount/APPLY_FAMIGLIA",
  SET_SEMESTRALE = "discount/SET_SEMESTRALE",
  SET_VOUCHER = "discount/SET_VOUCHER",
  SET_DISCOUNT_SEMESTRALE = "discount/SET_DISCOUNT_SEMESTRALE",
  CLEAR_ERROR = "discount/CLEAR_ERROR",
  CONFIRM_SELECTION = "discount/CONFIRM_SELECTION",
}

export const discountInitialState: DiscountState = {
  applied: false,
  calculating: false,
  error: "",
  prezzo: undefined,
  semestrale: false,
  voucher: "",
};

export const discountReducer = (state: DiscountState = discountInitialState, action: IAction): DiscountState => {
  switch (action.type) {
    case EngineActionType.BACK:
    case EngineActionType.BACK_TO_STEP:
      return discountInitialState; // Clean state

    case DiscountActionType.SET_VOUCHER:
      return {
        ...state,
        voucher: action.payload,
        calculating: false,
        applied: false,
        error: "",
      };
    case REQUEST(DiscountActionType.SET_SEMESTRALE):
    case REQUEST(DiscountActionType.APPLY_VOUCHER):
    case REQUEST(DiscountActionType.APPLY_FAMIGLIA):
    case REQUEST(DiscountActionType.CONFIRM_SELECTION):
      return {
        ...state,
        applied: false,
        calculating: true,
        error: "",
        semestrale: action.payload !== undefined ? action.payload : state.semestrale,
      };

    case SUCCESS(DiscountActionType.APPLY_FAMIGLIA):
    case SUCCESS(DiscountActionType.SET_SEMESTRALE):
    case SUCCESS(DiscountActionType.APPLY_VOUCHER):
      return {
        ...state,
        applied: Boolean(action.payload.voucher),
        calculating: false,
        error: "",
        prezzo: action.payload.premio,
        prezzoAnnuo: action.payload.premioAnnuo,
      };

    case SUCCESS(DiscountActionType.CONFIRM_SELECTION):
      return {
        ...state,
        error: "",
      };

    case FAILURE(DiscountActionType.APPLY_FAMIGLIA):
    case FAILURE(DiscountActionType.SET_SEMESTRALE):
    case FAILURE(DiscountActionType.APPLY_VOUCHER):
    case FAILURE(DiscountActionType.CONFIRM_SELECTION):
      return {
        ...state,
        applied: false,
        calculating: false,
        error: action.error,
      };

    case DiscountActionType.CLEAR_ERROR:
      return {
        ...state,
        error: "",
      };

    default:
      return state;
  }
};

// Action creator

// Thunk util
const errorHandler =
  (dispatch: Dispatch, action: string) =>
  (error: any): void => {
    const { data } = error.response;
    dispatch({ type: FAILURE(action), error: data.title });
  };

// Thunk
export const setSemestrale =
  (semestrale: boolean) =>
  (dispatch: Dispatch, getState: () => IStore): void => {
    const state = getState();
    const prev = preventivoSelector(state);
    if (prev) {
      prev.frazionamento = semestrale ? 2 : 1;
      dispatch({ type: REQUEST(DiscountActionType.SET_SEMESTRALE), payload: semestrale });
      Api.priceCalculation(prev)
        .then((data) => {
          dispatch({ type: SUCCESS(DiscountActionType.SET_SEMESTRALE), payload: data });
        })
        .catch(errorHandler(dispatch, DiscountActionType.SET_SEMESTRALE));
    }
  };

export const applyVoucher =
  () =>
  (dispatch: Dispatch, getState: () => IStore): void => {
    const state = getState();
    const prev = preventivoSelector(state);
    if (prev) {
      dispatch({ type: REQUEST(DiscountActionType.APPLY_VOUCHER) });
      Api.priceCalculation(prev)
        .then((data) => {
          dispatch({ type: SUCCESS(DiscountActionType.APPLY_VOUCHER), payload: data });
        })
        .catch(errorHandler(dispatch, DiscountActionType.APPLY_VOUCHER));
    }
  };

export const applyFamiglia =
  () =>
  (dispatch: Dispatch, getState: () => IStore): void => {
    const state = getState();
    const prev = preventivoSelector(state);
    if (prev) {
      dispatch({ type: REQUEST(DiscountActionType.APPLY_FAMIGLIA) });
      Api.priceCalculation(prev)
        .then((data) => {
          dispatch({ type: SUCCESS(DiscountActionType.APPLY_FAMIGLIA), payload: data });
        })
        .catch(errorHandler(dispatch, DiscountActionType.APPLY_FAMIGLIA));
    }
  };

export const confirmSelections =
  () =>
  (dispatch: Dispatch, getState: () => IStore): void => {
    const state = getState();
    const prev = preventivoSelector(state);
    if (prev) {
      dispatch({ type: REQUEST(DiscountActionType.CONFIRM_SELECTION) });
      Api.postCheckoutInit(prev)
        .then((data) => {
          dispatch({ type: SUCCESS(DiscountActionType.CONFIRM_SELECTION) });
          window.location.replace(data.url);
        })
        .catch(errorHandler(dispatch, DiscountActionType.CONFIRM_SELECTION));
    }
  };
